export default "__VITE_ASSET__DekruLx4__"